<div class="container-fluid">
  <!-- Tabbed interface with enhanced styling -->
  <ul class="nav nav-tabs mb-3">
    <li class="nav-item">
      <a class="nav-link"
         [class.active]="activeTab === 'thongtinchung'"
         [style.font-weight]="activeTab === 'thongtinchung' ? 'bold' : 'normal'"
         [style.color]="activeTab === 'thongtinchung' ? 'red' : ''"
         (click)="setActiveTab('thongtinchung')">
        <i class="fas fa-info-circle mr-1"></i> Thông tin chung
      </a>
    </li>
    <li class="nav-item">
      <a class="nav-link"
         [class.active]="activeTab === 'phanbo'"
         [style.font-weight]="activeTab === 'phanbo' ? 'bold' : 'normal'"
         [style.color]="activeTab === 'phanbo' ? 'red' : ''"
         (click)="setActiveTab('phanbo')">
        <i class="fas fa-chart-pie mr-1"></i> Phân bổ doanh thu
      </a>
    </li>
  </ul>

  <div class="tab-content">
    <!-- Tab 1: Thông tin chung -->
    <div id="thongtinchung" class="tab-pane fade" [class.active]="activeTab === 'thongtinchung'" [class.show]="activeTab === 'thongtinchung'">
      <div class="row ng-scope">
        <div class="col-12">

          <div class="row form-group">
          
            <label class="control-label col-2">Ngày đăng ký <span class="required">(*)</span></label>
            <div class="col-4">
              <kendo-dateinput tabindex="2" style="width:100%;" [format]="'dd/MM/yyyy'" [(value)]="doituongSelect.NgayDangKy"></kendo-dateinput>
            </div>
            <label class="control-label col-2"> Ngày kết thúc</label>
            <div class="col-4">
              <kendo-dateinput tabindex="2" style="width:100%;" [format]="'dd/MM/yyyy'" [(value)]="doituongSelect.NgayKetThuc"></kendo-dateinput>
            </div>
          </div>

          <div class="row form-group">
            <label class="control-label col-2 ng-binding">Khóa học</label>
            <div class="col-4">
              <ng-select #slKhoaHoc
                         class="twcollong"
                         [tabIndex]="3"
                         [openOnEnter]="false"
                         [items]="dskhoahocs"
                         bindValue="Id"
                         bindLabel="Ten"
                         notFoundText="Không có dữ liệu"
                         [searchFn]="comboSearchFn2"
                         (change)="changeTrangThai($event)"
                         [(ngModel)]="doituongSelect.KhoaHocId">
                <ng-template ng-footer-tmp>
                  <a (click)="AddKhoaHoc()"><em class="mr-2 far fa-plus-square"></em>Thêm mới</a>
                </ng-template>
                <ng-template ng-option-tmp let-item="item">
                  <div class="rTableRow">
                    <div class="rTableCell_1">{{item.Ten}}</div>
                  </div>
                </ng-template>
              </ng-select>
            </div>
            <label class="control-label col-2 ng-binding">Lớp học<span class="required">(*)</span></label>
            <div class="col-4">
              <ng-select #slLop
                         class="twcollong"
                         [tabIndex]="4"
                         [openOnEnter]="false"
                         [items]="dslops"
                         bindValue="Id"
                         bindLabel="Ten"
                         [searchFn]="comboSearchFn2"
                         notFoundText="Không có dữ liệu"
                         [(ngModel)]="doituongSelect.LopId">
                <ng-template ng-option-tmp let-item="item">
                  <div class="rTableRow">
                    <div class="rTableCell_1">{{item.Ten}}</div>
                  </div>
                </ng-template>
              </ng-select>
            </div>
          </div>

          <div class="row form-group">
            <label class="control-label col-2 ng-binding">Loại<span class="required">(*)</span></label>
            <div class="col-2">
              <ng-select #slDangKy
                         class="twcollong"
                         [tabIndex]="6"
                         [openOnEnter]="false"
                         [items]="inputloaikhoans"
                         bindValue="Id"
                         bindLabel="Ten"
                         notFoundText="Không có dữ liệu"
                         [searchFn]="comboSearchFn2"
                         [(ngModel)]="doituongSelect.Nhom">
                <ng-template ng-option-tmp let-item="item">
                  <div class="rTableRow">
                    <div class="rTableCell_1">{{item.Ten}}</div>
                  </div>
                </ng-template>
              </ng-select>
            </div>
            <label class="control-label col-2 ng-binding">Số buổi</label>
            <div class="col-2">
              <input class="form-control"
                     maxlength="20"
                     tabindex="7"
                     currencyMask
                     [(ngModel)]="doituongSelect.SoBuoi"
                     name="value"
                     [placeholder]="''"
                     [options]="ngxCurrencyOptions" autocomplete="off" />
            </div>
            <label class="control-label col-2 ng-binding">Số tiền</label>
            <div class="col-2">
              <input class="form-control"
                     maxlength="20"
                     tabindex="5"
                     currencyMask
                     [(ngModel)]="doituongSelect.GiaPhi"
                     (ngModelChange)="changeGiaPhi()"
                     name="value"
                     [placeholder]="''"
                     [options]="ngxCurrencyOptions" autocomplete="off" />
            </div>
          </div>

          <div class="row form-group">

            <label class="control-label col-2 ng-binding">Được giảm</label>
            <div class="col-2">
              <input class="form-control"
                     maxlength="20"
                     tabindex="8"
                     currencyMask
                     [(ngModel)]="doituongSelect.DuocGiam"
                     (ngModelChange)="changeDuocGiam()"
                     name="value"
                     [placeholder]="''"
                     [options]="ngxCurrencyOptions" autocomplete="off" />
            </div>

            <label class="control-label col-2 ng-binding">tính theo phần trăm</label>
            <div class="col-2">
              <input class="form-control"
                     maxlength="20"
                     max="100"
                     min="0"
                     tabindex="9"
                     currencyMask
                     [(ngModel)]="doituongSelect.TyLe"
                     (ngModelChange)="changeTyLe()"
                     name="value"
                     [placeholder]="''"
                     [options]="ngxCurrencyOptions" autocomplete="off" />
            </div>
            <label class="control-label col-2 ng-binding">Thực thu<span class="required">(*)</span></label>
            <div class="col-2">
              <input class="form-control"
                     maxlength="20"
                     tabindex="11"
                     currencyMask
                     [(ngModel)]="doituongSelect.ThucThu"
                     name="value"
                     [placeholder]="''"
                     [options]="ngxCurrencyOptions" autocomplete="off" />
            </div>
          </div>

          <div class="row form-group">
            <label class="control-label col-2 ng-binding">Nội dung</label>
            <div class="col-10">
              <textarea type="text" tabIndex="10" rows="5" class="form-control" placeholder="" [(ngModel)]="doituongSelect.LyDoGiam"></textarea>
            </div>
          </div>

          <div class="row form-group">
            <label class="control-label col-2 ng-binding">Ghi chú</label>
            <div class="col-10">
              <textarea type="text" tabIndex="13" rows="2" class="form-control" placeholder="" [(ngModel)]="doituongSelect.GhiChu"></textarea>
            </div>
          </div>

        </div>
      </div>
    </div>

    <!-- Tab 2: Phân bổ doanh thu -->
    <div id="phanbo" class="tab-pane fade" [class.active]="activeTab === 'phanbo'" [class.show]="activeTab === 'phanbo'">
      <div class="row">
        <div class="col-12">
          <!-- Khu vực thông tin phân bổ -->
          <div class="row form-group">
            <label class="control-label col-2">Số tiền phân bổ</label>
            <div class="col-4">
              <input class="form-control" currencyMask [options]="ngxCurrencyOptions" [(ngModel)]="doituongSelect.ThucThu" disabled autocomplete="off" />
            </div>
          </div>

          <div class="row form-group">
            <label class="control-label col-2">Thời gian phân bổ</label>
            <div class="col-2">
              <label>Từ tháng</label>
              <select class="form-control" [(ngModel)]="tuThang">
                <option *ngFor="let month of months" [value]="month">{{month}}</option>
              </select>
            </div>
            <div class="col-2">
              <label>Năm</label>
              <select class="form-control" [(ngModel)]="tuNam">
                <option *ngFor="let year of years" [value]="year">{{year}}</option>
              </select>
            </div>
            <div class="col-2">
              <label>Đến tháng</label>
              <select class="form-control" [(ngModel)]="denThang">
                <option *ngFor="let month of months" [value]="month">{{month}}</option>
              </select>
            </div>
            <div class="col-2">
              <label>Năm</label>
              <select class="form-control" [(ngModel)]="denNam">
                <option *ngFor="let year of years" [value]="year">{{year}}</option>
              </select>
            </div>
            <div class="col-2">
              <button class="btn btn-primary mt-4" style="background-color: #7b1fa2; border-color: #7b1fa2;" (click)="phanBoDoanhThu()">
                <i class="fas fa-calculator"></i> Phân bổ
              </button>
            </div>
          </div>

          <!-- Danh sách phân bổ -->
          <div class="mt-4">
            <h4 class="font-weight-bold">Danh sách doanh thu phân bổ</h4>

            <table class="table table-bordered mt-3">
              <thead class="thead-light">
                <tr>
                  <th>STT</th>
                  <th>Ngày</th>
                  <th>Số tiền</th>
                  <th>Ghi chú</th>
                  <th>Thao tác</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngIf="danhSachPhanBo.length === 0">
                  <td colspan="5" class="text-center">Không có bản ghi nào</td>
                </tr>
                <tr *ngFor="let item of danhSachPhanBo; let i = index">
                  <td>{{ i + 1 }}</td>
                  <td>{{ item.Ngay | date: 'dd/MM/yyyy' }}</td>
                  <td>{{ item.SoTien | currency:'':'':'1.0-0' }}</td>
                  <td>{{ item.GhiChu }}</td>
                  <td>
                    <button class="btn btn-sm btn-danger" (click)="xoaPhanBo(i)">
                      <i class="fas fa-trash-alt"></i>
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Voucher section -->
<div class="row" style="display:none;">
  <label class="text-danger font-weight-bold">
    Sử dụng voucher được tặng (lưu ý: sau khi chọn xong voucher cần nhấn nút TÍNH VOUCHER để cập nhật gói phí)
  </label>

  <table class="table table-bordered mt-2">
    <thead class="thead-light">
      <tr>
        <th>STT</th>
        <th>IDVoucher</th>
        <th>Loại voucher</th>
        <th>Mã giảm giá</th>
        <th>Số tiền giảm</th>
        <th>
          <button type="button" class="btn btn-sm btn-primary" style="margin-right:3px">Thêm mới</button>
          <button type="button" class="btn btn-sm btn-warning"><i class="fas fa-calculator" style="padding-right:2px"></i>Tính voucher</button>
        </th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let v of vouchers; let i = index">
        <td>{{ i + 1 }}</td>
        <td>{{ v.IDVoucher }}</td>
        <td>{{ v.LoaiVoucher }}</td>
        <td>{{ v.MaGiamGia }}</td>
        <td>{{ v.SoTienGiam }}</td>
        <td>
          <button class="btn btn-sm btn-danger" (click)="xoaVoucher(i)">X</button>
        </td>
      </tr>
    </tbody>
  </table>
</div>

<!-- Footer section -->
<div class="modal-footer" style="display: flex;justify-content: space-between;">
  <div style="display:flex;">
    <div class="checkbox c-checkbox">
      <label>
        <input tabIndex="18" type="checkbox" [(ngModel)]="doituongSelect.ApDungChoCalop" />
        <span class="fa fa-check"></span> Áp dụng cho cả lớp
      </label>
    </div>
  </div>
  <div class="">
    <button *ngIf="!(quyen_sua==false && doituongSelect.Id!=null)" type="submit" (click)="saveproduct()" title="Ấn F9 để lưu" class="mb-1 mr-1 btn btn-primary">Lưu lại</button>
    <button class="mb-1 mr-1 btn btn-secondary" (click)="closeModal()" title="Ấn ESC để thoát">Hủy bỏ</button>
  </div>
</div>


<!-- Modal khóa học -->
<bs-modal #myModal class="modal fade show in" [cssClass]="'modal800'" [backdrop]="'static'" [keyboard]="true">
  <div class="modal-header">
    <h4 class="modal-title">{{'Thêm khóa học' | translate}}</h4>
    <button type="button" aria-label="Dismiss" class="close" (click)="myModal.close()">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <bs-modal-body>
    <app-daotao-thongtinkhoahocedit #dteChung (save)="saveModal($event)"></app-daotao-thongtinkhoahocedit>
  </bs-modal-body>
</bs-modal>

